class showVatMode {
  constructor() {
    this.showVat = true;
    this.checkVat();
    this.init();
  }

  checkVat = () => {
    if (localStorage.getItem('showVat')) {
      this.showVat = JSON.parse(localStorage.getItem('showVat'));
    }

    // Set active classes on switch elements
    const elemOn = document.querySelector('[data-vat-status-on]');
    const elemOff = document.querySelector('[data-vat-status-off]');
    elemOn.classList.toggle('text-primary', this.showVat);
    elemOn.classList.toggle('text-primary-300', !this.showVat);
    elemOff.classList.toggle('text-primary', !this.showVat);
    elemOff.classList.toggle('text-primary-300', this.showVat);

    // Check all elements that have VAT specified on them
    document.querySelectorAll('[data-price-toggle-vat]').forEach((containerElem) => {
      containerElem.querySelectorAll('[data-price-vat-included]').forEach((elemIncVat) => {
        elemIncVat.hidden = !this.showVat;
      });
      containerElem.querySelectorAll('[data-price-vat-excluded]').forEach((elemIncVat) => {
        elemIncVat.hidden = this.showVat;
      });
    });
  };

  init = () => {
    document.querySelectorAll('[name="showVat"]').forEach((elem) => {
      elem.checked = this.showVat;

      elem.addEventListener('change', (e) => {
        localStorage.setItem('showVat', e.target.checked);
        this.checkVat();
      });
    });

    // Observe the body for changes
    const vatObserver = new MutationObserver((mutationList, observer) => {
      this.checkVat();
    });
    vatObserver.observe(document.querySelector('body'), {
      attributes: false,
      childList: true,
      subtree: true,
    });
  };
}

const showVatInit = new showVatMode();
